import pxToRem from "../../functions/pxToRem";

export default function dialogActions({ colors, borders }) {
  const { grey } = colors;
  const { borderWidth } = borders;

  const dialogActions = {
    styleOverrides: {
      root: {
        padding: `${pxToRem(16)} ${pxToRem(24)} ${pxToRem(20)}`,
        borderTop: `${borderWidth[1]} solid ${grey[200]}`,
        backgroundColor: grey[100],
        gap: pxToRem(12),

        "& .MuiButton-root": {
          minWidth: pxToRem(90),
          textTransform: "none",
          fontWeight: 600,
          borderRadius: pxToRem(8),
          padding: `${pxToRem(8)} ${pxToRem(20)}`,
        },

        "& .MuiButton-contained": {
          boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",

          "&:hover": {
            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.15)",
          },
        },
      },
    },
  };

  return dialogActions;
}
